module.exports = __webpack_public_path__ + "img/product01.c0952d1e.jpg";